// extracted by mini-css-extract-plugin
export default {"selectAll":"DropdownMultiselect_selectAll__GLeAF"};